var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Text } from '@amzn/atoz-web/Text';
import { useTranslation } from 'react-i18next';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { GenericModalTypes, GenericModalWithIconContent } from '../../shared';
import { Col } from '@amzn/atoz-web/Col';
import { timeDifferenceWithDurationString } from '@amzn/atoz-shiftapp-utilities';
import { DateTime } from 'luxon';
import { View } from '@amzn/atoz-web/View';
import { Row } from '@amzn/atoz-web';
export var InstantSwapModalSuccess = function (_a) {
    var close = _a.close, allScheduleDaysForDay = _a.allScheduleDaysForDay, newShift = _a.newShift, siteId = _a.siteId;
    var t = useTranslation().t;
    var dateOfShifts = DateTime.fromISO(newShift.timeRange.start);
    var hasMultipleShifts = allScheduleDaysForDay.length > 1;
    return (React.createElement(GenericModalWithIconContent, { dataTestId: "InstantSwapModalSuccess", mainText: t('shift_management_features_AcceptInstantSwap_success'), onClose: close, buttons: [
            React.createElement(StyledButton, { key: "1", variant: ButtonVariant.Primary, onClick: close, dataTestId: "InstantSwapModalSuccessDoneButton" }, t('shift_management_features_AcceptInstantSwap_success_buttonText'))
        ], type: GenericModalTypes.success },
        React.createElement(Col, { gridGap: "S300", margin: { top: 'S300' } },
            React.createElement(Text, { dataTestId: "InstantSwapModalSuccess_description", fontWeight: "medium" }, t('shift_management_features_AcceptInstantSwap_success_subtitle')),
            React.createElement(Text, { dataTestId: "swapShiftString", lineHeight: 0.5 }, dateOfShifts
                .toLocaleString({
                weekday: 'short',
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            })
                .toUpperCase()),
            hasMultipleShifts ? (React.createElement(View, { backgroundColor: "neutral05", padding: ['S300', 'S400'], margin: { top: 'S100' }, dataTestId: "InstantSwapModalSuccess_MultipleSwapShiftList" },
                allScheduleDaysForDay.map(function (_a) {
                    var timeRange = _a.timeRange;
                    return (React.createElement(View, { key: "SwapShift-".concat(timeRange.start, "-").concat(timeRange.end), padding: { top: 'S200', bottom: 'S200' } },
                        React.createElement(Text, { dataTestId: "SwapShiftDurationString", fontWeight: "medium" }, timeDifferenceWithDurationString(DateTime.fromISO(timeRange.start), DateTime.fromISO(timeRange.end)))));
                }),
                React.createElement(Row, { padding: { top: 'S100' } },
                    React.createElement(Text, null, siteId)))) : (React.createElement(View, { backgroundColor: "neutral05", padding: ['S300', 'S400'], margin: { top: 'S100' }, dataTestId: "InstantSwapModalSuccess_SingleSwapShiftList", key: "SwapShift-".concat(newShift.timeRange.start, "-").concat(newShift.timeRange.end) },
                React.createElement(Text, { dataTestId: "SwapShiftDurationString", fontWeight: "medium" }, timeDifferenceWithDurationString(DateTime.fromISO(newShift.timeRange.start), DateTime.fromISO(newShift.timeRange.end))),
                React.createElement(Row, { padding: { top: 'S100' } },
                    React.createElement(Text, null, siteId)))))));
};
var StyledButton = styledWithTheme(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1;
